<template>
  <div class="chart-shell">
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
    />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      default: () => [],
    },
    datasets: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    maxValue() {
      return this.datasets.reduce((max, dataset) => {
        const values = Array.isArray(dataset.data) ? dataset.data : [];
        const datasetMax = values.reduce((innerMax, value) => {
          const numericValue = Number(value) || 0;
          return numericValue > innerMax ? numericValue : innerMax;
        }, 0);
        return datasetMax > max ? datasetMax : max;
      }, 0);
    },
    chartOptions() {
      const smallRange = this.maxValue <= 10;
      return {
        responsive: true,
        maintainAspectRatio: false,
        resizeDelay: 100,
        interaction: {
          mode: "index",
          intersect: false,
        },
        plugins: {
          legend: {
            position: "top",
            labels: {
              color: "#6b7280",
              boxWidth: 28,
              font: {
                size: 11,
              },
            },
          },
          tooltip: {
            displayColors: true,
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(148, 163, 184, 0.12)",
              drawBorder: false,
            },
            ticks: {
              color: "#6b7280",
              autoSkip: true,
              maxRotation: 0,
              maxTicksLimit: 8,
              font: {
                size: 11,
              },
            },
          },
          y: {
            beginAtZero: true,
            suggestedMax: Math.max(1, this.maxValue),
            grid: {
              color: "rgba(148, 163, 184, 0.14)",
              drawBorder: false,
            },
            ticks: {
              color: "#6b7280",
              precision: 0,
              stepSize: smallRange ? 1 : undefined,
              font: {
                size: 11,
              },
            },
          },
        },
      };
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: this.datasets,
      };
    },
  },
};
</script>

<style>
.chart-shell {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.chart-shell canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
